import React from 'react';
import { Link } from 'react-router-dom';
import { ATMButton } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';

interface IProps {
  handleSave: (shouldReturn: boolean) => void;
  loading?: boolean;
}

const NewDispatchActionButtons: React.FC<IProps> = ({
  handleSave,
  loading = false,
}) => {
  return (
    <div>
      <ATMButton
        basic
        color="blue"
        content={Lang.LBL_CLOSE}
        as={Link}
        to="/dispatch"
      />
      <ATMButton
        basic
        color="blue"
        content={Lang.LBL_SAVE}
        onClick={() => handleSave(false)}
        loading={loading}
        disabled={loading}
      />
      <ATMButton
        basic
        color="blue"
        content={Lang.LBL_SAVE_RETURN}
        onClick={() => handleSave(true)}
        loading={loading}
        disabled={loading}
      />
    </div>
  );
};

export default NewDispatchActionButtons;
